var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickmarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#59ad29;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-664.042 -656.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(664.042 656.042)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669.118 663.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.135,68.252a.869.869,0,0,0-1.23,0L5.488,78.67l-4-4A.87.87,0,0,0,.254,75.9l4.619,4.619a.87.87,0,0,0,1.23,0L17.135,69.482A.87.87,0,0,0,17.135,68.252Z",
    transform: "translate(0 -67.998)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmarkIcon);
export default __webpack_public_path__ + "static/media/tickmark-icon.dc2fd25510d2d75fcf87f488c28101c5.svg";
export { ForwardRef as ReactComponent };